export const menu = [
  {
    title: 'Home',
    path: '/',
  },
  {
    title: 'Jawaabo',
    path: '/jawaab',
  },
  {
    title: 'Mawduucyo',
    path: '/categories',
  },
  {
    title: 'Culimada',
    path: '/authors',
  },
  // {
  //   title: 'Suaalo',
  //   path: '/question',
  // },

  
];
